import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { IDS, RoleId, WithdrawStatus } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import dayjs from "dayjs";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const {
    register,
    reset: formReset,
    handleSubmit,
    formState: { errors: formError },
  } = useForm();

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [showSubscribe, setShowSubscribe] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const today = new Date().toISOString().split("T")[0]; // Format today as YYYY-MM-DD
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [type, setType] = useState();
  const roleOptions = [
    { label: "All", value: "" },
    { label: "Accepted", value: "1" },
    { label: "Pending", value: "3" },
    { label: "Rejected", value: "2" },
  ];
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    validateDates(e.target.value, endDate);
  };

  // Handle End Date change
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    validateDates(startDate, e.target.value);
  };

  // Validate Dates
  const validateDates = (start, end) => {
    let newErrors = {};
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    // Validate Start Date
    if (start && startDateObj > new Date(today)) {
      newErrors.startDate = "Start date must be today or in the past";
    }

    // Validate End Date
    // if (end && endDateObj <= startDateObj) {
    //   newErrors.endDate = "End date must be greater than start date";
    // }

    setErrors(newErrors);
  };
  const [loading, setLoading] = useState(false);

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/wallet/withdraw-request?page=${onPageChange}&per_page=${perPage}&term=${search || ""}&type=${Number(type?.value) || ""}&startDate=${startDate}&endDate=${endDate}`,
    );
    await setData(response);

    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(
      `/admin/wallet/withdraw-request/${id}`,
    );
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [pendingStatusChange, setPendingStatusChange] = useState({
    value: null,
    id: null,
  });

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/admin/wallet/withdraw-request/${recordToDeleteId}`,
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  const handleStatusChange = async (value, id) => {
    if (Number(value) === 2) {
      setPendingStatusChange({ value, id });
      setShowRemarkModal(true);
    } else {
      const data = {
        withdraw_status_id: value,
      };
      const response = await postData(
        `/admin/wallet/withdraw-status/${id}`,
        data,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.data });
        setShowRemarkModal(false);
        setRemark("");
        formReset();
        setPendingStatusChange({ value: null, id: null });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }

      setTimeout(() => {
        setShowModal(0);
        formReset();
      }, 1000);
      setChangeStatus(response);
    }
  };

  const handleRemarkSubmit = async (formData) => {
    const { value, id } = pendingStatusChange;
    const data = {
      withdraw_status_id: value,
      remark: formData?.remark,
      status: true,
    };
    const response = await postData(
      `/admin/wallet/withdraw-status/${id}`,
      data,
    );

    if (response?.success) {
      await setShowModal({ code: response.code, message: response.data });
      setShowRemarkModal(false);
      setRemark("");
      formReset();
      setPendingStatusChange({ value: null, id: null });
    } else {
      await setShowModal({ code: response?.code, message: response?.errors });
    }
    setTimeout(() => {
      setShowModal(0);
      formReset();
    }, 1000);
    setChangeStatus(response);
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        const fileName = `Withdraw_Request_${dayjs().format("DDMMMYYYY").toLowerCase()}`;

        await getDownloadDataExcel(
          `/admin/wallet/withdraw-request/download?page=${onPageChange}&per_page=${perPage}&term=${search || ""}&type=${Number(type?.value) || ""}&startDate=${startDate}&endDate=${endDate}`,
          null,
          fileName,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [selectOrders, setSelectOrders] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [bulkMessage, setBulkMessage] = useState("");

  const [showBulkAcceptModal, setShowBulkAcceptModal] = useState(false);

  const handleSelectUser = (id) => {
    setSelectOrders((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  const handleSelectAll = (checked) => {
    setIsAllSelected(checked);
    if (!checked) {
      setSelectOrders([]);
    }
  };

  const handleBulkAccept = async () => {
    const finalData = new FormData();
    finalData.append("is_all", isAllSelected);
    finalData.append("order_ids", JSON.stringify(selectOrders));
    finalData.append("withdraw_status_id", WithdrawStatus.Accept);
    const response = await postData(
      "/admin/wallet/withdraw-status/bulk",
      finalData,
    );

    if (response?.success) {
      await setShowModal({ code: response.code, message: response.data });
      setShowBulkAcceptModal(false);
      setSelectOrders([]);
      setIsAllSelected(false);
      setChangeStatus(response);
    } else {
      await setShowModal({ code: response?.code, message: response?.errors });
    }

    setTimeout(() => {
      setShowModal(0);
    }, 1000);
    setChangeStatus(response);

    // if (response?.success) {
    //   setShowBulkAcceptModal(false);
    //   setSelectOrders([]);
    //   setIsAllSelected(false);
    //   setChangeStatus(response);
    // }
  };
  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Withdraw Request"}
          link={"/admin/wallet/withdraw-request"}
        />
        <section className="AdvanceDashboard">
          <section className="Tabels tab-radio tab-radio mt-3">
            <div className="">
              {/* container */}
              <div className="row p-2">
                {/* <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="border-line mt-3" />
                     

                      <div className="package-details-section-top-heading">
                        <div className="pending-table ">
                          <div className="d-flex  align-items-center">
                           

                            <div className="text-center  ms-5">
                              <Button onClick={() => setShowEdit(1)}>
                                + Add Money
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                <div className="border-line mt-3"></div>

                <div className="row mt-4">
                  <div className=" col-12">
                    <div className="">
                      <div className="  top-showing-wrapper sowing ms-3 me-2">
                        {" "}
                        <p className="show m-0">Show</p>{" "}
                        <select
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          onChange={(e) => {
                            setonPageChange(1);
                            setperPage(e.target.value);
                          }}
                        >
                          {option?.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <p className="show m-0">
                          {" "}
                          entries{" "}
                          {`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.total,
                          )} of ${data?.data?.total} entries`}
                        </p>
                      </div>
                    </div>
                    {/* </div>
                        <div className="   col-12"> */}
                    <div className="row align-items-end">
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        From
                        <div className="num">
                          <Form.Control
                            type="date"
                            isInvalid={!!errors.startDate}
                            min="0001-01-01"
                            max="9999-12-31"
                            className="form-control"
                            placeholder="Start Date"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              setEndDate("");
                              setonPageChange(1);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.startDate}
                          </Form.Control.Feedback>
                        </div>
                      </div>

                      {/* End Date */}
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6  col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        To
                        <div className="num">
                          <Form.Control
                            type="date"
                            isInvalid={!!errors.endDate}
                            className="form-control"
                            min={startDate ? startDate : "0001-01-01"}
                            max="9999-12-31"
                            placeholder="to"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.endDate}
                          </Form.Control.Feedback>
                        </div>
                      </div>

                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6  col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        Type
                        <div className="num">
                          <Select
                            options={roleOptions}
                            value={type}
                            defaultValue={roleOptions[0] || []}
                            onChange={(e) => setType(e)}
                            placeholder="Type"
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                        <div>
                          <button
                            className="btn btn-success "
                            type="button"
                            onClick={HandleDownload}
                          >
                            Download Excel
                            <FontAwesomeIcon
                              icon="fa-solid fa-file-lines"
                              className="ms-2"
                            />
                          </button>
                        </div>
                      </div>
                      {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-4  col-12 mt-2 px-1">
                            <div className="Search">
                              <Button
                                variant="success"
                                disabled={
                                  !selectOrders.length > 0 && !isAllSelected
                                }
                                className="px-1"
                                onClick={() => setShowBulkAcceptModal(true)}
                              >
                                Accept Selected (
                                {isAllSelected ? "All" : selectOrders.length})
                              </Button>
                            </div>
                          </div> */}
                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                        <div className="Search me-2">
                          <Button
                            type="button"
                            onClick={() => {
                              setonPageChange(1);
                              getDataAll();
                            }}
                            className="btn btn-search"
                          >
                            Search
                          </Button>
                        </div>
                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setStartDate("");
                              setEndDate("");
                              setType(roleOptions[0]);
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-line mt-3"></div>
              <div className="row mt-3 p-1">
                <div className="data table-responsive">
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr className="">
                        {/* <th style={{ width: "5%" }}>
                              <Form.Check
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                              />
                            </th> */}
                        {visible.col1 && (
                          <th className="sr" style={{ width: "10%" }}>
                            Sr. No.
                          </th>
                        )}
                        {visible.col2 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Date Time
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Customer Name
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Amount
                          </th>
                        )}
                        {/* {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Charges
                              </th>
                            )} */}

                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Account Holder Name
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Bank & Branch Name
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Account No
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            IFSC Code
                          </th>
                        )}
                        {visible.col5 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Status
                          </th>
                        )}
                        {visible.col4 && (
                          <th className="tax-name" style={{ width: "200px" }}>
                            Action
                          </th>
                        )}

                        {/* {visible.col6 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Description
                              </th>
                            )} */}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        data?.data?.data?.map((d, index) => {
                          const paginatedIndex =
                            (onPageChange - 1) * perPage + index + 1;
                          return (
                            <tr className="" key={index}>
                              {/* <td>
                                   

                                    <Form.Check
                                      type="checkbox"
                                      disabled={d?.Withdraw_Status?.id !== 3}
                                      checked={selectOrders.includes(d.id)}
                                      onChange={() => handleSelectUser(d.id)}
                                    />
                                  </td> */}
                              {visible.col1 && <td>{paginatedIndex}.</td>}
                              {visible.col2 && (
                                <td>
                                  {new Date(d?.createdAt).toLocaleString(
                                    "en-IN",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: false,
                                    },
                                  )}
                                </td>
                              )}
                              {visible.col3 && <td>{d?.User?.name}</td>}
                              {visible.col3 && <td>₹ {d?.net_amount}</td>}
                              {/* {visible.col3 && (
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <div>
                                        <strong>Requested:</strong> ₹{d?.amount}
                                      </div>
                                      {Number(d?.tds_amount) > 0 && (
                                        <div>
                                          <strong>
                                            TDS ({d?.tds_percentage}%):
                                          </strong>{" "}
                                          ₹{d?.tds_amount}
                                        </div>
                                      )}
                                      {Number(d?.admin_charge_amount) > 0 && (
                                        <div>
                                          <strong>
                                            Admin ({d?.admin_charge_percentage}
                                            %):
                                          </strong>{" "}
                                          ₹{d?.admin_charge_amount}
                                        </div>
                                      )}
                                      <div>
                                        <strong>Net:</strong> ₹
                                        {d?.net_amount || d?.amount}
                                      </div>
                                    </td>
                                  )}{" "} */}
                              {visible.col3 && <td>{d?.banking_name}</td>}
                              {visible.col3 && <td>{d?.branch_name}</td>}
                              {visible.col3 && <td>{d?.account_no}</td>}
                              {visible.col3 && <td>{d?.ifsc_code}</td>}
                              {/* {visible.col4 && (
                                  <td
                                    style={{
                                      color:
                                        d?.transaction_type === "debit"
                                          ? "red"
                                          : "green",
                                    }}
                                  >
                                    {d?.transaction_type}
                                  </td>
                                )}*/}
                              {visible.col5 && (
                                <td>{d?.Withdraw_Status?.name || "_"}</td>
                              )}
                              {visible.col6 && (
                                <td>
                                  {d.Withdraw_Status?.id === 3 && (
                                    <select
                                      style={{ width: "100px" }}
                                      value={d?.status || ""}
                                      onChange={(e) =>
                                        handleStatusChange(e.target.value, d.id)
                                      }
                                      className="form-select"
                                    >
                                      <option value="">Select</option>
                                      <option value={1}>Accept</option>
                                      <option value={2}>Reject</option>
                                    </select>
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                  {data && data?.data?.data?.length > 0 ? (
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  ) : (
                    <p className="no-datashow">Sorry, No Data Found</p>
                  )}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <Modal
        show={showBulkAcceptModal}
        onHide={() => setShowBulkAcceptModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-exclamation-triangle text-warning me-2"></i>
            Confirm Acceptance
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <h5>Accept selected withdrawal requests?</h5>

            <p className="text-muted mb-0">
              You are about to accept{" "}
              <strong>{isAllSelected ? "All " : selectOrders.length}</strong>{" "}
              pending withdrawal
              {selectOrders.length > 1 ? " requests" : " request"}.
            </p>

            <p className="text-danger mt-2 mb-0">
              <strong>This action cannot be undone.</strong>
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowBulkAcceptModal(false)}
          >
            Cancel
          </Button>

          <Button variant="success" onClick={handleBulkAccept}>
            Yes, Accept
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRemarkModal}
        onHide={() => setShowRemarkModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Remark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Remark</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter remark..."
              maxLength={250}
              className={classNames("", {
                "is-invalid": formError?.remark,
              })}
              {...register("remark", {
                required: "Remark is required",

                maxLength: {
                  value: 250,
                  message: "Remark cannot exceed 250 characters",
                },

                validate: (value) =>
                  value?.trim()?.length > 0 || "Remark is required",
              })}
            />

            {formError?.remark && (
              <span className="text-danger">{formError?.remark?.message}</span>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRemarkModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(handleRemarkSubmit)}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
